import type { ThemeConfig } from 'antd';

/**
 * Base design tokens for the admin application. Per-project brand theming
 * (colors, typography) will later be layered on top of this at runtime by
 * merging project brand settings into the AntD theme algorithm.
 */
export const baseTheme: ThemeConfig = {
  token: {
    colorPrimary: '#4f46e5',
    borderRadius: 8,
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 14,
  },
  components: {
    Layout: {
      bodyBg: '#f5f6fa',
    },
    Button: {
      controlHeight: 40,
    },
  },
};
